<!-- ======= Portfolio Section ======= -->
<section id="portfolio" class="portfolio section-bg">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Portafolio</h2>
      <!-- <p>
        Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex
        aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos
        quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat
        sit in iste officiis commodi quidem hic quas.
      </p> -->
    </div>

    <div class="row">
      <div
        class="col-lg-12 d-flex justify-content-center"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <ul id="portfolio-flters">
          <li data-filter=".filter-web">Angular App</li>
          <li data-filter=".filter-app">Mobile App</li>
          <li data-filter=".filter-card">Services</li>
          <li data-filter="*" class="filter-active">Todo</li>
        </ul>
      </div>
    </div>

    <div
      class="row portfolio-container"
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <div
        *ngFor="let port of portafolio"
        class="col-lg-4 col-md-6 portfolio-item"
        [class]="port.tipoFilter"
      >
        <div class="portfolio-wrap">
          <img [src]="port.img" class="img-fluid" alt="" />
          <div class="portfolio-info">
            <h4>{{ port.subtitulo }}</h4>
            <p>{{ port.descripcion }}</p>
            <div class="portfolio-links">
              <a
                [href]="port.github"
                class="portfolio-details-lightbox"
                data-glightbox="type: external"
                title="Portfolio Details"
                ><i class="bx bxl-github"></i
              ></a>
              <a
                [href]="port.direccionWeb"
                class="portfolio-details-lightbox"
                data-glightbox="type: external"
                title="Web Address"
                ><i class="bx bxl-chrome"></i
              ></a>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
              <img src="assets/img/portfolio/portfolio-2.jpg" class="img-fluid" alt="">
              <div class="portfolio-info">
                <h4>Web 3</h4>
                <p>Web</p>
                <div class="portfolio-links">
                  <a href="assets/img/portfolio/portfolio-2.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web 3"><i class="bx bx-plus"></i></a>
                  <a href="portfolio-details.html" class="portfolio-details-lightbox" data-glightbox="type: external" title="Portfolio Details"><i class="bx bx-link"></i></a>
                </div>
              </div>
            </div>
          </div> -->
    </div>
  </div>
</section>
<!-- End Portfolio Section -->
